<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="text-background-fg/70 mb-1 block text-left text-xs font-medium"
    >
      {{ label }}
    </label>
    <div class="relative rounded-md">
      <input
        :type="type"
        :name="name"
        :class="[
          'border-1 border-background-fg/8 block w-full rounded-md text-sm font-semibold focus:outline-none sm:text-sm',
          hasError
            ? 'border-error text-error placeholder-error focus:border-error focus:ring-error'
            : 'focus:ring-primary focus:border-primary',
        ]"
        :placeholder="placeholder"
        :value="inputValue"
        :aria-invalid="hasError"
        enterkeyhint="done"
        :disabled="disabled"
        :maxlength="maxlength"
        @change="handleChange"
        @blur="handleBlur"
      />
    </div>
    <template v-if="hasError">
      <p class="text-error mt-1 text-xs font-medium">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = withDefaults(
  defineProps<{
    type?: string
    name: string
    label?: string
    placeholder?: string
    disabled?: boolean
    maxlength?: number
  }>(),
  {
    modelValue: "",
    type: "text",
    label: "",
    placeholder: "",
    disabled: false,
    maxlength: undefined,
  }
)

const name = toRef(props, "name")

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(name, undefined, {
  initialValue: undefined,
})

const hasError = computed(
  () => !!errorMessage.value && meta.touched
)
</script>
